import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { createCategory, updateCategory } from "../../services/CategoryService";
import CategoryForm from "../../components/CategoryForm";
import AppModal from "../../components/Modal";
import yup from "../../utils/yup";

const CategoryFormModal = ({ data = null, open, onClose, setCategories }) => {
  const categoryForm = yup
    .object()
    .shape({
      name: yup
        .string()
        .typeError("The name of the category is not valid.")
        .required("The name of the category is required.")
        .min(2, "The name of the category must be larger than 2 characters."),
      color: yup
        .object()
        .shape({
          hex: yup
            .string()
            .typeError("The color is not valid.")
            .test(
              "category-color-hex",
              "The color is not a valid hexadecimal color.",
              (val) =>
                !val || RegExp("^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$").test(val)
            )
            .nullable(),
        })
        .nullable()
        .default(null),
    })
    .required();

  const formDetails = {
    submitButtonLabel: "Submit",
    steps: [
      {
        name: "name",
        label: "Category name",
        type: "text",
      },
      {
        name: "color",
        label: "Color",
        type: "color-picker",
      },
    ],
  };

  const form = useForm({
    resolver: yupResolver(categoryForm),
    mode: "onChange",
  });

  const onSubmit = (values) => {
    if (data) {
      updateCategory(form.setError)(values).then((data) => {
        toast.success(`The category ${data.name} has been updated.`);
        setCategories((oldVal) =>
          oldVal.map((i) => {
            if (i.id === data.id) {
              return data;
            }
            return i;
          })
        );
        onClose();
      });
    } else {
      createCategory(form.setError)(values).then((data) => {
        toast.success(`The category ${data.name} has been created.`);
        setCategories((oldVal) => [...oldVal, data]);
        onClose();
      });
    }
  };

  return (
    <AppModal
      open={open}
      onClose={onClose}
      title={`${data ? "Update" : "Create"} a category`}
    >
      <CategoryForm
        formDetails={formDetails}
        data={data}
        onSubmit={onSubmit}
        form={form}
        additionalButtons={
          <Button onClick={onClose} className="mt-4" variant="outline-danger">
            Close
          </Button>
        }
      />
    </AppModal>
  );
};

export default CategoryFormModal;
